import React, { useEffect } from "react";
import { bool, func, object, string } from "prop-types";
import { Link } from "@quintype/components";
import get from "lodash/get";

import LoadMoreAuthorStories from "./load-more-authors";
import Icon from "../../icons";
import Stories2AdWithLoadMore from "../../rows/Stories2AdWithLoadMore";
import { NotFoundPage } from "../not-found/index";
import Image from "../../atoms/Image";

import { fireVirtualPageOnSPA } from "../../utils/utils";

import "./author.m.css";

const AuthorPage = ({ data, config }) => {
  const { stories, totalCount } = data;
  const { author } = data.author;
  const authorImg = author["avatar-s3-key"] || author["avatar-url"];
  const NO_OF_STORIES_TO_LOAD = 10;
  const facebookHandle = get(author, ["metadata", "Facebook"], null);
  const emailAddress = get(author, ["metadata", "Author Contact Email"], null);
  const publicAuthor = get(author, ["metadata", "Public Author"], null);
  if (!String(publicAuthor).toLocaleLowerCase().includes("yes")) {
    return <NotFoundPage />;
  }
  useEffect(() => {
    handleReload();
  }, [author]);
  const handleReload = () => {
    if (document.readyState === "complete") {
      fireVirtualPageOnSPA("Authors", author.name, "", data.title);
    }
  };
  return (
    <React.Fragment>
      <div styleName="author-page-wrapper">
        <div styleName="wrapper">
          <div styleName="content">
            <h1 styleName="author-title">{author.name}</h1>
            {author.bio && <span className="sub-title">{author.bio}</span>}
            <div styleName="icon-wrapper">
              {facebookHandle && (
                <Link
                  aria-label="facebook link"
                  href={`https://www.facebook.com/${facebookHandle}`}
                  className="social-icon"
                >
                  <Icon type="fb-whitebg" className="fb-whitebg" />
                </Link>
              )}
              {author["twitter-handle"] && (
                <Link
                  aria-label="twitter link"
                  href={`https://www.twitter.com/${author["twitter-handle"]}`}
                  className="social-icon"
                >
                  <Icon type="twitter-whitebg" className="twitter-whitebg" />
                </Link>
              )}
              {emailAddress && (
                <Link aria-label="email address" href={`mailto:${emailAddress}`} className="social-icon">
                  <Icon type="envelope" className="envelope" />
                </Link>
              )}
            </div>
          </div>
          <div styleName="picture-wrapper">
            {authorImg ? (
              author["avatar-s3-key"] ? (
                <Image
                  slug={author["avatar-s3-key"]}
                  aspectRatio={[1, 1]}
                  defaultWidth={200}
                  widths={[200]}
                  styleName="picture"
                  alt={author.name}
                />
              ) : (
                <img styleName="picture" src={author["avatar-url"]} alt={author.name} />
              )
            ) : (
              <Icon type="default-author-image" />
            )}
          </div>
        </div>
        <div>
          <LoadMoreAuthorStories
            template={(e) => MoreCollectionStories(e, totalCount)}
            authorID={author.id}
            data={{ collection: null, stories: stories, config: config }}
            numStoriesToLoad={NO_OF_STORIES_TO_LOAD}
            params={{ "item-type": "story" }}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

const MoreCollectionStories = ({ stories, onLoadMore, loading }, totalCount) => {
  return (
    <Stories2AdWithLoadMore
      list={stories}
      loading={loading}
      onLoadMore={onLoadMore}
      isMoreStories={totalCount > stories.length}
      isBorderTop={true}
    />
  );
};

AuthorPage.propTypes = {
  data: object,
  config: object,
  story: object,
};

MoreCollectionStories.propTypes = {
  stories: object,
  collection: object,
  onLoadMore: func,
  noMoreStories: string,
  config: object,
  loading: bool,
};

export { AuthorPage };
